<template>
  <div class="w-full">
    <div
      class="mt-4 bg-gray-50 border border-gray-200 flex flex-col items-center content-center justify-center py-24 space-y-8"
      v-if="polling"
    >
      <DotPulse />
      <span>This may take a few minutes...</span>
    </div>

    <ul class="mt-4 space-y-2 divide-gray-200" v-if="!polling">
      <li v-for="sale in sales" v-bind:key="sale.id">
        <div
          class="bg-white rounded-md overflow-hidden px-4 py-4 sm:px-6 flex flex-row items-center content-center group relative"
        >
          <div class="flex-1">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-800 truncate">
                {{ sale.video.title }}
              </p>
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex">
                <div
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 space-x-1"
                >
                  <span class="flex-shrink-0 h-5 w-5 flex items-center">
                    <i class="fad fa-building"></i>
                  </span>
                  <p>{{ sale.network.name }}</p>
                </div>
                <div
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6 space-x-1"
                >
                  <span class="flex-shrink-0 h-5 w-5 flex items-center">
                    <i class="fas fa-user"></i>
                  </span>
                  <p>
                    {{ sale.owner.name
                    }}<i
                      class="fa-regular fa-circle-exclamation ml-1 text-red-600"
                      v-if="sale.owner.w9_timestamp == null"
                      v-tippy
                      title="User has not submitted a W-9 form yet."
                    ></i>
                  </p>
                </div>
                <div
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6 space-x-1"
                >
                  <span class="flex-shrink-0 h-5 w-5 flex items-center">
                    <i class="fas fa-coins"></i>
                  </span>
                  <p>${{ sale.price }}</p>
                </div>
                <div
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6 space-x-1"
                  v-if="sale.video.credit !== null"
                >
                  <span class="flex-shrink-0 h-5 w-5 flex items-center">
                    <i class="fa-solid fa-wallet"></i>
                  </span>
                  <p>{{ sale.video.credit }} credits</p>
                </div>

                <!-- <div
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6"
                  v-tippy
                  title="Invoice Reference"
                >
                  <span class="flex-shrink-0 h-5 w-5 flex items-center">
                    <i class="fad fa-file-invoice"></i>
                  </span>
                  <p>{{ sale.invoice_number }}</p>
                </div> -->
              </div>

              <div
                class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 space-x-1"
              >
                <!-- Heroicon name: solid/calendar -->
                <span class="flex-shrink-0 h-5 w-5 flex items-center">
                  <i class="fad fa-calendar-check"></i>
                </span>
                <p>
                  Purchased on
                  <span
                    >{{ sale.created_at | displayLocalDateTime("M/D/YYYY") }}
                    at
                    {{ sale.created_at | displayLocalDateTime("h:mm a") }}</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li v-if="polling">
        <div class="flex items-center justify-center py-5">
          <h1 class="text-2xl">
            <i class="fa fa-circle-notch fa-spin text-black"></i>
          </h1>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import * as Config from "@/config";

import Dropdown from "@/components/partials/Dropdown";
import ApproveVideoSaleModal from "@/screens/admin/modals/ApproveVideoSaleModal";
import SegmentedControl from "@/components/general/SegmentedControl";
import DotPulse from "@/components/Loaders/DotPulse";

export default {
  name: "HelloWorld",
  data() {
    return {
      sales: [],
      polling: true
    };
  },
  components: {
    Dropdown,
    ApproveVideoSaleModal,
    SegmentedControl,
    DotPulse
  },
  mounted() {
    this.getSales();
  },
  methods: {
    async getSales() {
      let res = await this.$http.get(
        Config.apiPath + "/api/v2/admin/sales/paginate?type=complete"
      );
      this.sales = res.data.data;

      this.polling = false;
    },
    openViewSaleModal(data) {
      this.$eventBus.$emit("admin-approve-sale-open-modal", data);
    },
    tabSelected(tab) {
      console.log(tab);
    }
  }
};
</script>
